<template>
  <div>
    <v-row color="deep-purple accent-3" class="mb-4" v-if="editable">
      <v-toolbar :color="this.$pgsHelper.uiConfig().mainColor" dark>
        <v-text-field
          v-model="roomData.Nombre"
          hide-details
          single-line
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn @click="deleteArea()" icon>
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <v-btn @click="saveArea()" icon> Guardar </v-btn>
      </v-toolbar>
    </v-row>
    <v-row>
      <v-col v-if="editable" class="col-md-2">
        <v-form ref="form" lazy-validation>
          <v-select
            v-model="typeObj"
            :items="itemsObj"
            label="Objeto"
            outlined
          ></v-select>
          <v-text-field v-model="nombre" label="Nombre" required></v-text-field>

          <v-checkbox
            v-model="useCuenta"
            label="Permite Cuenta"
            required
          ></v-checkbox>

          <v-btn @click="addItem()" color="success" class="mr-4"> Crear </v-btn>
        </v-form>
      </v-col>
      <v-col
        v-bind:class="[editable ? 'col-md-10' : 'col-md-12']"
        style="overflow-x: auto"
      >
        <v-row v-if="editable">
          <v-col md="2">
            <v-text-field
              v-model="wArea"
              @change="changeCanvasSize()"
              label="Ancho de area (Metros)"
            ></v-text-field>
          </v-col>
          <v-col md="2">
            <v-text-field
              v-model="hArea"
              @change="changeCanvasSize()"
              label="Alto de area (Metros)"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-btn text @click="removeSelected()" color="red" dark>
              Eliminar Objeto
            </v-btn>
          </v-col>
        </v-row>
        <v-row
          v-show="loadingData"
          class="fill-height"
          align-content="center"
          justify="center"
        >
          <v-col class="subtitle-1 text-center" cols="12">
            Cargando el mapa {{ roomData.Nombre }}
          </v-col>
          <v-col cols="6">
            <v-progress-linear
              color="deep-purple accent-4"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </v-col>
        </v-row>
        <img
          v-show="false"
          ref="imgCar"
          width="100px"
          src="../../../../assets/img/golfCar.png"
        />
        <div v-if="noClick">
          <canvas ref="canvas" width="1200" height="300"></canvas>
        </div>
        <canvas v-else ref="canvas" width="1200" height="300"></canvas>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogSecurityTable" persistent max-width="390">
      <v-card>
        <v-card-title class="headline"> Abrir Mesa </v-card-title>

        <v-card-text>
          Proporcione su código para continuar
          <v-text-field label="Código" v-model="codigoEmpleado"></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialogSecurityTable = false"
          >
            Cancelar
          </v-btn>

          <v-btn color="green darken-1" text @click="continueTable()">
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { fabric } from "fabric";
import TableRestaurant from "../../../../clases/TableRestaurant.js";
import { mapGetters, mapState, mapMutations } from "vuex";
import Mesero from "../../../../clases/Restaurante/Mesero.js";
import moment from "moment";
export default {
  name: "floorRestaurant",
  components: {},
  props: [
    "editable",
    "roomData",
    "noClick",
    "reservationView",
    "reservationDate",
    "reservationSelected",
    "mainReservas",
    "mainInputDate",
    "contenedores",
  ],
  data() {
    return {
      itemsObj: [
        { value: "table", text: "Mesa" },
        { value: "roundTable", text: "Mesa Circular" },
        { value: "bar", text: "Bar" },
        { value: "chair", text: "Silla" },
        { value: "golfCar", text: "Carro Golf" },
      ],
      loadingData: true,
      hArea: 8,
      wArea: 8,
      nombre: "",
      useCuenta: true,
      typeObj: "table",
      grid: 30,
      backgroundColor: "#f8f8f8",
      lineStroke: "#ebebeb",
      tableFill: "rgba(150, 111, 51, 0.7)",
      tableStroke: "#694d23",
      tableShadow: "rgba(0, 0, 0, 0.4) 3px 3px 7px",
      chairFill: "rgba(67, 42, 4, 0.7)",
      chairStroke: "#32230b",
      chairShadow: "rgba(0, 0, 0, 0.4) 3px 3px 7px",
      barFill: "rgba(0, 93, 127, 0.7)",
      barStroke: "#003e54",
      barShadow: "rgba(0, 0, 0, 0.4) 3px 3px 7px",
      barText: "Bar",
      carFill: "rgba(255, 255, 255, 0.7)",
      wallFill: "rgba(136, 136, 136, 0.7)",
      wallStroke: "#686868",
      wallShadow: "rgba(0, 0, 0, 0.4) 5px 5px 20px",
      canvas: "",
      dialogOpenTable: false,
      dialogSecurityTable: false,
      cashierMode: true,
      selectClient: "PUBLICOGENERAL",
      selectMesero: "",
      codigoEmpleado: "",
      openTableData: {
        Contenedor: { Id: "", Nom: "" },
        Comensales: 1,
        Mesero: { Id: "", Nom: "" },
        Cliente: { Id: "PUBLICOGENERAL", Nom: "", Apd: "" },
      },
      fromData: [],
    };
  },
  computed: {
    ...mapGetters([
      "getFirebaseApp",
      "getSignInData",
      "getProductosCategorias",
      "isOnline",
    ]),
    ...mapGetters("dataLists", ["getClientes", "getAybMeseros"]),
    comp_clients() {
      let clientes = [];
      this.getClientes.forEach((cli) => {
        let nombre = cli.Nombres + " " + cli.Apellidos;
        if (cli.Apodo) {
          nombre = nombre + " (" + cli.Apodo + ")";
        }
        clientes.push({
          id: cli.id,
          value: cli.id,
          text: nombre,
        });
      });
      return clientes;
    },
    comp_meseros() {
      let meseros = [];
      this.getAybMeseros.forEach((mesero) => {
        if (mesero.Deptos) {
          if (
            mesero.Deptos[this.roomData?.Mapa?.Departamento] &&
            mesero.Activo
          ) {
            meseros.push(mesero);
          }
        }
      });

      return meseros;
    },
  },
  methods: {
    addItem() {
      if (this.typeObj == "table") {
        this.addRect(0, 0, 60, 90, {
          Nombre: this.nombre,
          useCuenta: this.useCuenta,
          id: this.generate_token(32),
          object: { scaleX: 1, scaleY: 1 },
        });
      } else if (this.typeObj == "roundTable") {
        this.addCircle(0, 0, 30, {
          Nombre: this.nombre,
          useCuenta: this.useCuenta,
          id: this.generate_token(32),
          object: { scaleX: 1, scaleY: 1 },
        });
      } else if (this.typeObj == "bar") {
        this.addBar(0, 0, 180, 60, {
          Nombre: this.nombre,
          useCuenta: this.useCuenta,
          id: this.generate_token(32),
          object: { scaleX: 1, scaleY: 1 },
        });
      } else if (this.typeObj == "chair") {
        this.addChair(0, 0, {
          Nombre: this.nombre,
          useCuenta: this.useCuenta,
          id: this.generate_token(32),
          object: { scaleX: 1, scaleY: 1 },
        });
      } else if (this.typeObj == "golfCar") {
        this.addGolfCar(0, 0, 80, 110, {
          Nombre: this.nombre,
          useCuenta: this.useCuenta,
          id: this.generate_token(32),
          object: { scaleX: 1, scaleY: 1 },
        });
      }
      this.nombre = null;
      this.useCuenta = false;
    },
    sendLinesToBack() {
      this.canvas.getObjects().map((o) => {
        if (o.type === "line") {
          this.canvas.sendToBack(o);
        }
      });
    },
    parseClientName(text) {
      text = text.split(" ").join("\n");
      return text;
    },
    addRect(left, top, width, height, params) {
      const id = Math.random();

      const o = new fabric.Rect({
        width: width,
        height: height,
        fill: params.color, //this.tableFill,
        stroke: params.object.Open
          ? params.impreso
            ? "rgba(231,165,45)"
            : "rgba(76, 175, 80, 1)"
          : this.tableStroke, //this.tableStroke,
        strokeWidth: 2,
        shadow: this.tableShadow,
        originX: "center",
        originY: "center",
        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
      });
      let testString = "";
      if (params.object.Open) {
        if (params?.object?.contenedor?.Estado?.Cliente?.Apd) {
          if (params?.object?.contenedor?.Estado?.Cliente?.Apd !== "") {
            testString =
              params.Nombre + " " + params.object.contenedor.Estado.Cliente.Apd;
          } else {
            testString =
              params.Nombre +
              " " +
              params?.object?.contenedor?.Estado?.Cliente?.Nom;
          }
        } else {
          testString =
            params.Nombre +
            " " +
            params?.object?.contenedor?.Estado?.Cliente?.Nom;
        }
      } else {
        testString = params.Nombre;
      }

      let tableText = this.parseClientName(testString); //params.Nombre;

      const t = new fabric.IText(tableText, {
        fontFamily: "Calibri",
        fontSize: 12,
        fill: "#fff",
        textAlign: "center",
        lockUniScaling: true,
        originX: "center",
        originY: "center",
      });
      const g = new fabric.Group([o, t], {
        left: left,
        top: top,
        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
        type: "table",
        scaleX: params?.object?.scaleX,
        scaleY: params?.object?.scaleY,
        angle: params.angle ? params.angle : 0,
        Nombre: params.Nombre,
        useCuenta: params.useCuenta,
        id: params.id,
        number: id,
      });
      if (params.useCuenta && params.object.contenedor) {
        g.on("mousedown", (e) => {
          // e.target should be the circle
          if (!this.editable) {
            this.clickItem(e.target);
          }
        });
      }

      this.canvas.add(g);
    },
    addGolfCar(left, top, width, height, params) {
      const id = Math.random();
      const o = new fabric.Rect({
        width: width,
        height: height,
        fill: params.color,
        stroke: params.object.Open
          ? params.impreso
            ? "rgba(231,165,45)"
            : "rgba(101, 183, 3, 0.7)"
          : this.tableStroke,
        strokeWidth: 2,
        shadow: this.tableShadow,
        originX: "center",

        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
      });
      let testString = params.object.Open
        ? params.object?.contenedor?.Estado?.Cliente?.Apd
          ? params.object?.contenedor?.Estado?.Cliente?.Apd !== ""
            ? params.Nombre +
              " " +
              params?.object?.contenedor?.Estado?.Cliente?.Apd
            : params.Nombre +
              " " +
              params?.object?.contenedor?.Estado?.Cliente?.Nom
          : params.Nombre +
            " " +
            params?.object?.contenedor?.Estado?.Cliente?.Nom
        : params.Nombre;
      let tableText = this.parseClientName(testString); //params.Nombre;
      const t = new fabric.IText(tableText, {
        top: 5,
        fontFamily: "Calibri",
        fontSize: 14,
        fill: "#000",
        textAlign: "center",
        originX: "center",
      });

      const imageCar = new fabric.Image(this.$refs.imgCar, {
        top: 50,
        scaleX: 1 / 5,
        scaleY: 1 / 5,
        originX: "center",
      });

      const g = new fabric.Group([o, t, imageCar], {
        left: left,
        top: top,
        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
        type: "golfCar",
        scaleX: params?.object?.scaleX,
        scaleY: params?.object?.scaleY,
        Nombre: params.Nombre,
        angle: params.angle ? params.angle : 0,
        useCuenta: params.useCuenta,
        id: params.id,
        number: id,
      });
      if (params.useCuenta) {
        g.on("mousedown", (e) => {
          // e.target should be the circle
          if (!this.editable) {
            this.clickItem(e.target);
          }
        });
      }

      this.canvas.add(g);
      this.canvas.renderAll();
    },
    addChair(left, top, params) {
      const id = Math.random();

      const o = new fabric.Rect({
        left: left,
        top: top,
        width: 30,
        height: 30,
        fill: params.color,
        stroke: params.object.Open
          ? params.impreso
            ? "rgba(231,165,45)"
            : "rgba(101, 183, 3, 0.7)"
          : this.chairStroke,
        strokeWidth: 2,
        shadow: this.chairShadow,
        originX: "left",
        originY: "top",
        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
        scaleX: params?.object?.scaleX,
        scaleY: params?.object?.scaleY,
        type: "chair",
        Nombre: params.Nombre,
        useCuenta: params.useCuenta,
        id: params.id,
        angle: params.angle ? params.angle : 0,
        number: id,
      });

      if (params.useCuenta) {
        o.on("mousedown", (e) => {
          // e.target should be the circle
          if (!this.editable) {
            this.clickItem(e.target);
          }
        });
      }

      this.canvas.add(o);
    },
    addCircle(left, top, radius, params) {
      const id = Math.random();
      const o = new fabric.Circle({
        radius: radius,
        fill: params.color,
        stroke: params.object.Open
          ? params.impreso
            ? "rgba(231,165,45)"
            : "rgba(101, 183, 3, 0.7)"
          : this.tableStroke,
        strokeWidth: 2,
        shadow: this.tableShadow,
        originX: "center",
        originY: "center",
        centeredRotation: true,
      });
      let testString = params.object.Open
        ? params.object.contenedor.Estado.Cliente.Apd
          ? params.object.contenedor.Estado.Cliente.Apd !== ""
            ? params.Nombre +
              " " +
              params?.object?.contenedor?.Estado?.Cliente?.Apd
            : params.Nombre +
              " " +
              params?.object?.contenedor?.Estado?.Cliente?.Nom
          : params.Nombre +
            " " +
            params?.object?.contenedor?.Estado?.Cliente?.Nom
        : params.Nombre;
      let tableText = this.parseClientName(testString); //params.Nombre;

      const t = new fabric.IText(tableText, {
        fontFamily: "Calibri",
        fontSize: 14,
        fill: "#fff",
        textAlign: "center",
        originX: "center",
        originY: "center",
      });
      const g = new fabric.Group([o, t], {
        left: left,
        top: top,
        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
        scaleX: params?.object?.scaleX,
        scaleY: params?.object?.scaleY,
        Nombre: params.Nombre,
        useCuenta: params.useCuenta,
        angle: params.angle ? params.angle : 0,
        id: params.id,
        type: "roundTable",
        number: id,
      });

      if (params.useCuenta) {
        g.on("mousedown", (e) => {
          // e.target should be the circle
          if (!this.editable) {
            this.clickItem(e.target);
          }
        });
      }
      this.canvas.add(g);
      return g;
    },
    addBar(left, top, width, height, params) {
      const id = Math.random();
      const o = new fabric.Rect({
        width: width,
        height: height,
        fill: params.color,
        stroke: params.object.Open
          ? params.impreso
            ? "rgba(231,165,45)"
            : "rgba(101, 183, 3, 0.7)"
          : this.barStroke,
        strokeWidth: 2,
        shadow: this.barShadow,
        originX: "center",
        originY: "center",
        type: "bar",
        id: id,
      });
      let testString = params.object.Open
        ? params.object.contenedor?.Estado?.Cliente?.Apd
          ? params.object.contenedor?.Estado?.Cliente?.Apd !== ""
            ? params.object.contenedor?.Estado?.Cliente?.Apd
            : params.object.contenedor?.Estado?.Cliente?.Nom
          : params.object.contenedor?.Estado?.Cliente?.Nom
        : params.Nombre;
      let tableText = this.parseClientName(testString); //params.Nombre;
      const t = new fabric.IText(tableText, {
        fontFamily: "Calibri",
        fontSize: 14,
        fill: "#fff",
        textAlign: "center",
        originX: "center",
        originY: "center",
      });
      const g = new fabric.Group([o, t], {
        left: left,
        top: top,
        centeredRotation: true,
        snapAngle: 45,
        selectable: true,
        Nombre: params.Nombre,
        scaleX: params?.object?.scaleX,
        scaleY: params?.object?.scaleY,
        angle: params.angle ? params.angle : 0,
        useCuenta: params.useCuenta,
        id: params.id,
        type: "bar",
      });
      if (params.useCuenta) {
        g.on("mousedown", (e) => {
          // e.target should be the circle
          if (!this.editable) {
            this.clickItem(e.target);
          }
        });
      }
      this.canvas.add(g);
      return g;
    },
    deleteObject(eventData, transform) {
      this.$swal({
        title: "¿Deseas eliminar este elemento?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          var target = transform.target;
          var canvas = target.canvas;
          canvas.remove(target);
          canvas.requestRenderAll();
        }
      });
    },
    renderIcon(ctx, left, top, styleOverride, fabricObject) {
      let deleteIcon =
        "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Ebene_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='595.275px' height='595.275px' viewBox='200 215 230 470' xml:space='preserve'%3E%3Ccircle style='fill:%23F44336;' cx='299.76' cy='439.067' r='218.516'/%3E%3Cg%3E%3Crect x='267.162' y='307.978' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -222.6202 340.6915)' style='fill:white;' width='65.545' height='262.18'/%3E%3Crect x='266.988' y='308.153' transform='matrix(0.7071 0.7071 -0.7071 0.7071 398.3889 -83.3116)' style='fill:white;' width='65.544' height='262.179'/%3E%3C/g%3E%3C/svg%3E";

      var img = document.createElement("img");
      img.src = deleteIcon;
      var size = 20;
      ctx.save();
      ctx.translate(left, top);
      ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
      ctx.drawImage(img, -size / 2, -size / 2, size, size);
      ctx.restore();
    },
    removeSelected() {
      const o = this.canvas.getActiveObject();
      if (o) {
        this.$swal({
          title: "¿Deseas eliminar este elemento?",
          text: "",
          icon: "warning",
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Eliminar",
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            this.canvas.remove(o);
            this.canvas.discardActiveObject();
            this.canvas.renderAll();
          }
        });
      }
    },
    blockCanvas() {
      this.canvas.getObjects().map((o) => {
        o.hasControls = false;
        o.lockMovementX = true;
        o.lockMovementY = true;
      });
      this.canvas.selection = false;
      this.canvas.hoverCursor = "pointer";
      this.canvas.discardActiveObject();
      this.canvas.renderAll();
    },
    canvasToJson() {
      let data = this.canvas.toJSON(["Nombre", "id", "useCuenta"]);

      let objects = [];
      data.objects.forEach((obj) => {
        if (obj.type != "line") {
          objects.push(obj);
        }
      });
      return objects;
    },
    jsonToCanvas() {
      this.fromData.forEach((element) => {
        let impreso = false;
        if (element.contenedor) {
          if (element.contenedor.Estado) {
            if (element.contenedor.Estado.Cuentas) {
              let cuentas = Object.entries(element.contenedor.Estado.Cuentas);
              cuentas.forEach((cuenta) => {
                if (cuenta[1].estado === "T") {
                  impreso = true;
                }
              });
            }
          }
        }
        if (element.type == "table") {
          let color = "";

          if (this.noClick) {
            let reservasConMesa = this.reservationView
              .filter(
                (reserva) =>
                  reserva.ms &&
                  reserva.et !== "asignado" &&
                  reserva.et !== "cancelado"
              )
              .map((reserva) => ({
                id: reserva.ms.id,
                fr: reserva.fr,
                et: reserva.et,
              }));

            let reserva = this.$pgsHelper.getById(
              reservasConMesa,
              "id",
              element?.contenedor.id
            );

            let boolSelected = false;
            if (this.reservationSelected) {
              boolSelected =
                this.reservationSelected.id == element.contenedor.id;
            }

            if (this.reservationDate != null && this.reservationDate != "") {
              if (reserva) {
                const resFecha = reserva.fr.split("_")[0];
                const boolFecha = moment(resFecha).isSame(
                  moment(this.reservationDate),
                  "day"
                );
                color = boolSelected
                  ? "rgba(36, 92, 181)"
                  : boolFecha
                  ? "rgba(181, 36, 167)"
                  : element.Open
                  ? impreso
                    ? "rgba(231, 165, 45)"
                    : "rgba(76, 175, 80, 1)"
                  : this.tableFill;
              } else {
                color = boolSelected
                  ? "rgba(36, 92, 181)"
                  : element.Open
                  ? impreso
                    ? "rgba(231, 165, 45)"
                    : "rgba(76, 175, 80, 1)"
                  : this.tableFill;
              }
            } else {
              // Si no hay fecha seleccionada, no comparar fechas
              color = boolSelected
                ? "rgba(36, 92, 181)" // Color para mesa seleccionada
                : element.Open
                ? impreso
                  ? "rgba(231, 165, 45)"
                  : "rgba(76, 175, 80, 1)"
                : this.tableFill;
            }
          } else {
            if (this.mainReservas) {
              let reservaMs = this.mainReservas.map((reserva) => ({
                fr: reserva.fr,
                id: reserva.ms.id,
              }));
              let reserva = this.$pgsHelper.getById(
                reservaMs,
                "id",
                element.contenedor?.id
              );
              if (reserva) {
                const resFecha = reserva.fr.split("_")[0];
                const boolFecha = moment(resFecha).isSame(
                  moment(this.mainInputDate),
                  "day"
                );
                color = boolFecha
                  ? "rgba(181, 36, 167)"
                  : element.Open
                  ? impreso
                    ? "rgba(231, 165, 45)"
                    : "rgba(76, 175, 80, 1)"
                  : this.tableFill;
              } else {
                color = element.Open
                  ? impreso
                    ? "rgba(231, 165, 45)"
                    : "rgba(76, 175, 80, 1)"
                  : this.tableFill;
              }
            } else {
              color = element.Open
                ? impreso
                  ? "rgba(231, 165, 45)"
                  : "rgba(76, 175, 80, 1)"
                : this.tableFill;
            }
          }

          this.addRect(
            element.left,
            element.top,
            element.width,
            element.height,
            {
              Nombre: !element.useCuenta
                ? element.Nombre
                : element.contenedor
                ? element.Nombre
                : "cargando..",
              impreso: impreso,
              useCuenta: element.useCuenta,
              Apd: element.Apd,
              id: element.id,
              angle: element.angle,
              object: element,
              color: color,
            }
          );
        } else if (element.type == "chair") {
          let color = "";

          if (this.noClick) {
            let reservasConMesa = this.reservationView
              .filter(
                (reserva) =>
                  reserva.ms &&
                  reserva.et !== "asignado" &&
                  reserva.et !== "cancelado"
              )
              .map((reserva) => ({
                id: reserva.ms.id,
                fr: reserva.fr,
                et: reserva.et,
              }));

            let reserva = this.$pgsHelper.getById(
              reservasConMesa,
              "id",
              element.contenedor?.id
            );

            let boolSelected = false;
            if (this.reservationSelected) {
              boolSelected =
                this.reservationSelected.id == element.contenedor.id;
            }

            if (this.reservationDate != null && this.reservationDate != "") {
              if (reserva) {
                const resFecha = reserva.fr.split("_")[0];
                const boolFecha = moment(resFecha).isSame(
                  moment(this.reservationDate),
                  "day"
                );
                color = boolSelected
                  ? "rgba(36, 92, 181)"
                  : boolFecha
                  ? "rgba(181, 36, 167)"
                  : element.Open
                  ? impreso
                    ? "rgba(231,165,45)"
                    : "rgba(101, 183, 3, 0.7)"
                  : this.chairFill;
              } else {
                color = boolSelected
                  ? "rgba(36, 92, 181)"
                  : element.Open
                  ? impreso
                    ? "rgba(231,165,45)"
                    : "rgba(101, 183, 3, 0.7)"
                  : this.chairFill;
              }
            } else {
              // Si no hay fecha seleccionada, no comparar fechas
              color = boolSelected
                ? "rgba(36, 92, 181)" // Color para mesa seleccionada
                : element.Open
                ? impreso
                  ? "rgba(231,165,45)"
                  : "rgba(101, 183, 3, 0.7)"
                : this.chairFill;
            }
          } else {
            if (this.mainReservas) {
              let reservaMs = this.mainReservas.map((reserva) => ({
                fr: reserva.fr,
                id: reserva.ms.id,
              }));
              let reserva = this.$pgsHelper.getById(
                reservaMs,
                "id",
                element.contenedor?.id
              );
              if (reserva) {
                const resFecha = reserva.fr.split("_")[0];
                const boolFecha = moment(resFecha).isSame(
                  moment(this.mainInputDate),
                  "day"
                );
                color = boolFecha
                  ? "rgba(181, 36, 167)"
                  : element.Open
                  ? impreso
                    ? "rgba(231,165,45)"
                    : "rgba(101, 183, 3, 0.7)"
                  : this.chairFill;
              } else {
                color = element.Open
                  ? impreso
                    ? "rgba(231,165,45)"
                    : "rgba(101, 183, 3, 0.7)"
                  : this.chairFill;
              }
            } else {
              color = element.Open
                ? impreso
                  ? "rgba(231,165,45)"
                  : "rgba(101, 183, 3, 0.7)"
                : this.chairFill;
            }
          }

          this.addChair(element.left, element.top, {
            Nombre: element.Nombre,
            impreso: impreso,
            useCuenta: element.useCuenta,
            id: element.id,
            angle: element.angle,
            object: element,
            color: color,
          });
        } else if (element.type == "roundTable") {
          let color = "";

          if (this.noClick) {
            let reservasConMesa = this.reservationView
              .filter(
                (reserva) =>
                  reserva.ms &&
                  reserva.et !== "asignado" &&
                  reserva.et !== "cancelado"
              )
              .map((reserva) => ({
                id: reserva.ms.id,
                fr: reserva.fr,
                et: reserva.et,
              }));

            let reserva = this.$pgsHelper.getById(
              reservasConMesa,
              "id",
              element.contenedor?.id
            );

            let boolSelected = false;
            if (this.reservationSelected) {
              boolSelected =
                this.reservationSelected.id == element.contenedor.id;
            }

            if (this.reservationDate != null && this.reservationDate != "") {
              if (reserva) {
                const resFecha = reserva.fr.split("_")[0];
                const boolFecha = moment(resFecha).isSame(
                  moment(this.reservationDate),
                  "day"
                );
                color = boolSelected
                  ? "rgba(36, 92, 181)"
                  : boolFecha
                  ? "rgba(181, 36, 167)"
                  : element.Open
                  ? impreso
                    ? "rgba(231, 165, 45)"
                    : "rgba(76, 175, 80, 1)"
                  : this.tableFill;
              } else {
                color = boolSelected
                  ? "rgba(36, 92, 181)"
                  : element.Open
                  ? impreso
                    ? "rgba(231, 165, 45)"
                    : "rgba(76, 175, 80, 1)"
                  : this.tableFill;
              }
            } else {
              // Si no hay fecha seleccionada, no comparar fechas
              color = boolSelected
                ? "rgba(36, 92, 181)" // Color para mesa seleccionada
                : element.Open
                ? impreso
                  ? "rgba(231, 165, 45)"
                  : "rgba(76, 175, 80, 1)"
                : this.tableFill;
            }
          } else {
            if (this.mainReservas) {
              let reservaMs = this.mainReservas.map((reserva) => ({
                fr: reserva.fr,
                id: reserva.ms.id,
              }));
              let reserva = this.$pgsHelper.getById(
                reservaMs,
                "id",
                element.contenedor?.id
              );
              if (reserva) {
                const resFecha = reserva.fr.split("_")[0];
                const boolFecha = moment(resFecha).isSame(
                  moment(this.mainInputDate),
                  "day"
                );
                color = boolFecha
                  ? "rgba(181, 36, 167)"
                  : element.Open
                  ? impreso
                    ? "rgba(231,165,45)"
                    : "rgba(76, 175, 80, 1)"
                  : this.tableFill;
              } else {
                color = element.Open
                  ? impreso
                    ? "rgba(231,165,45)"
                    : "rgba(76, 175, 80, 1)"
                  : this.tableFill;
              }
            } else {
              color = element.Open
                ? impreso
                  ? "rgba(231,165,45)"
                  : "rgba(76, 175, 80, 1)"
                : this.tableFill;
            }
          }

          this.addCircle(element.left, element.top, 30, {
            Nombre: !element.useCuenta
              ? element.Nombre
              : element.contenedor
              ? element.Nombre
              : "cargando..",
            useCuenta: element.useCuenta,
            impreso: impreso,
            id: element.id,
            angle: element.angle,
            object: element,
            color: color,
          });
        } else if (element.type == "bar") {
          let color = "";

          if (this.noClick) {
            let reservasConMesa = this.reservationView
              .filter(
                (reserva) =>
                  reserva.ms &&
                  reserva.et !== "asignado" &&
                  reserva.et !== "cancelado"
              )
              .map((reserva) => ({
                id: reserva.ms.id,
                fr: reserva.fr,
                et: reserva.et,
              }));

            let reserva = this.$pgsHelper.getById(
              reservasConMesa,
              "id",
              element.contenedor?.id
            );

            let boolSelected = false;
            if (this.reservationSelected) {
              boolSelected =
                this.reservationSelected.id == element.contenedor.id;
            }

            if (this.reservationDate != null && this.reservationDate != "") {
              if (reserva) {
                const resFecha = reserva.fr.split("_")[0];
                const boolFecha = moment(resFecha).isSame(
                  moment(this.reservationDate),
                  "day"
                );
                color = boolSelected
                  ? "rgba(36, 92, 181)"
                  : boolFecha
                  ? "rgba(181, 36, 167)"
                  : element.Open
                  ? impreso
                    ? "rgba(231,165,45)"
                    : "rgba(101, 183, 3, 0.7)"
                  : this.barFill;
              } else {
                color = boolSelected
                  ? "rgba(36, 92, 181)"
                  : element.Open
                  ? impreso
                    ? "rgba(231,165,45)"
                    : "rgba(101, 183, 3, 0.7)"
                  : this.barFill;
              }
            } else {
              // Si no hay fecha seleccionada, no comparar fechas
              color = boolSelected
                ? "rgba(36, 92, 181)" // Color para mesa seleccionada
                : element.Open
                ? impreso
                  ? "rgba(231,165,45)"
                  : "rgba(101, 183, 3, 0.7)"
                : this.barFill;
            }
          } else {
            if (this.mainReservas) {
              let reservaMs = this.mainReservas.map((reserva) => ({
                fr: reserva.fr,
                id: reserva.ms.id,
              }));
              let reserva = this.$pgsHelper.getById(
                reservaMs,
                "id",
                element.contenedor?.id
              );
              if (reserva) {
                const resFecha = reserva.fr.split("_")[0];
                const boolFecha = moment(resFecha).isSame(
                  moment(this.mainInputDate),
                  "day"
                );
                color = boolFecha
                  ? "rgba(181, 36, 167)"
                  : element.Open
                  ? impreso
                    ? "rgba(231,165,45)"
                    : "rgba(101, 183, 3, 0.7)"
                  : this.barFill;
              } else {
                color = element.Open
                  ? impreso
                    ? "rgba(231,165,45)"
                    : "rgba(101, 183, 3, 0.7)"
                  : this.barFill;
              }
            } else {
              color = element.Open
                ? impreso
                  ? "rgba(231,165,45)"
                  : "rgba(101, 183, 3, 0.7)"
                : this.barFill;
            }
          }

          this.addBar(
            element.left,
            element.top,
            element.width,
            element.height,
            {
              Nombre: !element.useCuenta
                ? element.Nombre
                : element.contenedor
                ? element.Nombre
                : "cargando..",
              useCuenta: element.useCuenta,
              id: element.id,
              impreso: impreso,
              angle: element.angle,
              object: element,
              color: color,
            }
          );
        } else if (element.type == "golfCar") {
          let color = "";

          if (this.noClick) {
            let reservasConMesa = this.reservationView
              .filter(
                (reserva) =>
                  reserva.ms &&
                  reserva.et !== "asignado" &&
                  reserva.et !== "cancelado"
              )
              .map((reserva) => ({
                id: reserva.ms.id,
                fr: reserva.fr,
                et: reserva.et,
              }));

            let reserva = this.$pgsHelper.getById(
              reservasConMesa,
              "id",
              element.contenedor?.id
            );

            let boolSelected = false;
            if (this.reservationSelected) {
              boolSelected =
                this.reservationSelected.id == element.contenedor.id;
            }

            if (this.reservationDate != null && this.reservationDate != "") {
              if (reserva) {
                const resFecha = reserva.fr.split("_")[0];
                const boolFecha = moment(resFecha).isSame(
                  moment(this.reservationDate),
                  "day"
                );
                color = boolSelected
                  ? "rgba(36, 92, 181)"
                  : boolFecha
                  ? "rgba(181, 36, 167)"
                  : element.Open
                  ? impreso
                    ? "rgba(231,165,45)"
                    : "rgba(101, 183, 3, 0.7)"
                  : this.carFill;
              } else {
                color = boolSelected
                  ? "rgba(36, 92, 181)"
                  : element.Open
                  ? impreso
                    ? "rgba(231,165,45)"
                    : "rgba(101, 183, 3, 0.7)"
                  : this.carFill;
              }
            } else {
              // Si no hay fecha seleccionada, no comparar fechas
              color = boolSelected
                ? "rgba(36, 92, 181)" // Color para mesa seleccionada
                : element.Open
                ? impreso
                  ? "rgba(231,165,45)"
                  : "rgba(101, 183, 3, 0.7)"
                : this.carFill;
            }
          } else {
            if (this.mainReservas) {
              let reservaMs = this.mainReservas.map((reserva) => ({
                fr: reserva.fr,
                id: reserva.ms.id,
              }));
              let reserva = this.$pgsHelper.getById(
                reservaMs,
                "id",
                element.contenedor.id
              );
              if (reserva) {
                const resFecha = reserva.fr.split("_")[0];
                const boolFecha = moment(resFecha).isSame(
                  moment(this.mainInputDate),
                  "day"
                );
                color = boolFecha
                  ? "rgba(181, 36, 167)"
                  : element.Open
                  ? impreso
                    ? "rgba(231,165,45)"
                    : "rgba(101, 183, 3, 0.7)"
                  : this.carFill;
              } else {
                color = element.Open
                  ? impreso
                    ? "rgba(231,165,45)"
                    : "rgba(101, 183, 3, 0.7)"
                  : this.carFill;
              }
            } else {
              color = element.Open
                ? impreso
                  ? "rgba(231,165,45)"
                  : "rgba(101, 183, 3, 0.7)"
                : this.carFill;
            }
          }

          this.addGolfCar(
            element.left,
            element.top,
            element.width,
            element.height,
            {
              Nombre: !element.useCuenta
                ? element.Nombre
                : element.contenedor
                ? element.Nombre
                : "cargando..",
              useCuenta: element.useCuenta,
              Apd: element.Apd,
              impreso: impreso,
              id: element.id,
              angle: element.angle,
              object: element,
              color: color,
            }
          );
        }
      });
      this.loadingData = false;
    },
    generate_token(length) {
      var a =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split(
          ""
        );
      var b = [];
      for (var i = 0; i < length; i++) {
        var j = (Math.random() * (a.length - 1)).toFixed(0);
        b[i] = a[j];
      }
      let token = b.join("");
      let existToken = this.$pgsHelper.getById(
        this.canvasToJson(),
        "id",
        token
      );
      if (existToken) {
        token = this.generate_token();
      }

      return token;
    },
    generate_firebase_token() {
      let ref =
        this.$store.getters.getFirebaseApp.database.ref("AYB/Contenedores");
      let objRef = ref.push();
      let id = objRef.key;
      return id;
    },
    changeCanvasSize() {
      this.canvas.setHeight(this.hArea * 100);
      this.canvas.setWidth(this.wArea * 100);
      this.renderGrid();
    },
    deleteArea() {
      this.$emit("deleteArea", this.roomData);
    },
    saveArea() {
      this.roomData.Mapa = this.roomData.Mapa ? this.roomData.Mapa : {};
      this.roomData.Mapa.Alto = parseInt(this.hArea);
      this.roomData.Mapa.Ancho = parseInt(this.wArea);
      this.roomData.Mapa.Mapa = this.canvasToJson();
      this.roomData.Mapa.Area = this.roomData.Id;
      this.roomData.Deleted = this.deleted;
      this.$emit("updateArea", this.roomData);
    },
    renderGrid() {
      for (let i = 0; i < this.canvas.height / this.grid; i++) {
        const lineX = new fabric.Line(
          [0, i * this.grid, this.canvas.width, i * this.grid],
          {
            stroke: this.lineStroke,
            selectable: false,
            type: "line",
          }
        );

        this.sendLinesToBack();
        this.canvas.add(lineX);
      }

      for (let i = 0; i < this.canvas.width / this.grid; i++) {
        const lineY = new fabric.Line(
          [i * this.grid, 0, i * this.grid, this.canvas.height],
          {
            stroke: this.lineStroke,
            selectable: false,
            type: "line",
          }
        );
        this.sendLinesToBack();

        this.canvas.add(lineY);
      }
    },
    async clickItem(target) {
      console.log(this.roomData?.Mapa?.Departamento,target.id,this.contenedores)
      let mesas = await TableRestaurant.getTableById(
        this.roomData?.Mapa?.Departamento,
        target.id,
        this.contenedores
      );

      if (mesas) {
        if (mesas.Estado.E == 0) {
          // if(!this.cashierMode){
          this.openTableData.Contenedor.Id = target.id;
          this.$emit("triggerOpenTable", this.openTableData);
          //this.dialogOpenTable = true;
          //}
        } else if (mesas.Estado.E == 1) {
          if (this.noClick) {
            this.$emit("triggerOpenTable", this.openTableData);
          } else if (!this.cashierMode) {
            this.openTableData.Contenedor.Id = target.id;
            this.dialogSecurityTable = true;
          } else {
            this.$router.push({ path: "/sales-point-restaurant/" + target.id });
          }

          /*this.$router.push({ path: "/sales-point-restaurant/"+target.id });*/
        }
      } else {
        this.$toast.error(
          "La mesa ya no esta disponible en el mapa de restaurante, contacte a soporte"
        );
      }
    },
    async openTable() {
      let datos = this.openTableData;
      let mesa = await TableRestaurant.getTableById(
        this.roomData?.Mapa?.Departamento,
        datos.Contenedor.Id,
        this.contenedores
      );
      datos.Cliente.Nom = this.$pgsHelper.getById(
        this.comp_clients,
        "id",
        datos.Cliente.Id
      ).text;
      datos.Mesero.Nom = this.$pgsHelper.getById(
        this.getAybMeseros,
        "id",
        datos.Mesero.Id
      ).Nombre;
      datos.Contenedor.Nom = mesa.Nombre;
      datos.Comensales = Number(datos.Comensales);
      datos.Departamento = localStorage.getItem("ParGolfPDVDepartment");
      datos.DeptoAYB = localStorage.getItem("AYBDepartamento");
      this.$swal({
        title: "¿Deseas aperturar esta mesa?",
        text: "Se aperturara una cuenta al cliente seleccionado",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Abrir Mesa",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.getFirebaseApp.fba
            .call("AYB-Mesas-abrirMesa", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$router.push({
              path: "/sales-point-restaurant/" + datos.Contenedor.Id,
            });
          } else {
            this.$swal("Error abriendo mesa", result.value.data.error, "error");
          }
        }
      });
    },
    async continueTable() {
      this.$router.push({
        path: "/sales-point-restaurant/" + this.openTableData.Contenedor.Id,
      });
    },
    async initCanvas(existCanvas = null) {
      this.fromData = this.roomData.Mapa ? this.roomData.Mapa.Mapa : [];
      console.log(this.fromData)
      this.wArea = this.roomData.Mapa ? this.roomData.Mapa.Ancho : 8;
      this.hArea = this.roomData.Mapa ? this.roomData.Mapa.Alto : 8;
      let ref = this.$refs;
      /*let width = (window.innerWidth > 0) ? window.innerWidth  : screen.width;
      let height = (window.innerHeight > 0) ? window.innerHeight : screen.height; */
      if (!existCanvas) {
        this.canvas = new fabric.Canvas(this.$refs.canvas, {
          width: this.wArea * 100,
          height: this.hArea * 100,
        });
      } else {
        this.canvas.setHeight(this.hArea * 100);
        this.canvas.setWidth(this.wArea * 100);
      }

      fabric.Object.prototype.controls.deleteControl = new fabric.Control({
        x: 0.5,
        y: -0.5,
        offsetY: 16,
        cursorStyle: "pointer",
        mouseUpHandler: this.deleteObject,
        render: this.renderIcon,
        cornerSize: 24,
      });
      if (this.editable) {
        this.renderGrid();
      }
      this.canvas.selection = false;
      //this.addRect(40, 40, 60, 90,"Mesa 1");
      //setTimeout(() => {
      this.jsonToCanvas();
      // }, 1000);

      if (!this.editable) {
        //setTimeout(() => {
        this.blockCanvas();

        // }, 1000);
      }


    },
  },
  beforeMount: function () {},
  mounted: async function () {
    this.initCanvas();
  },
};
</script>
